import styled, { css } from "styled-components";
import { Container as ContainerLabelarea } from "@/main/components/common/columnLabel/styles";

interface IContainerRowProps {
	$expanded: boolean;
}
export const ContainerRow = styled.div<IContainerRowProps>`
	width: 100%;
	min-width: 800px;
	border: 1px solid ${({ theme }) => theme.grayDarker};
	border-radius: 4px;
	overflow: hidden;

	${({ $expanded, theme }) =>
		$expanded &&
		css`
			border-color: ${theme.pantone2727C};
		`}
`;
export const Container = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
	gap: 0.6rem;
	padding: 0.8rem;
	background: ${({ theme }) => theme.white};

	cursor: pointer;
	width: 100%;
	transition: background 0.3s ease-out;

	> ${ContainerLabelarea} {
		width: 100%;
		max-width: 600px;
	}

	&:hover {
		background: ${({ theme }) => theme.grayDarker};
	}
`;

export const AreaIcon = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	margin-left: auto;

	.MuiSvgIcon-root {
		color: ${({ theme }) => theme.pantone2726C};
	}
`;

export const HyperLink = styled.div`
	&&& {
		a {
			color: ${({ theme }) => theme.pantone2727C};
			text-decoration: underline;
			cursor: pointer;
		}
	}
`;

export const BoxModal = styled.div`
	background-color: #fff;
	border-radius: 8px;
	padding: 15px;
	max-width: 600px;
`;

export const TitleModal = styled.h6`
	font-weight: bold;
	color: #000;
	text-align: center;
`;
